 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"plotly":"plotly","lab-report":"lab-report"}[chunkId]||chunkId) + "." + {"chunk-071fba82":"f5c7ce71","chunk-0c5549d4":"8e99240b","chunk-0cf8451c":"d5c58438","chunk-0e331eef":"947ac856","chunk-0f73822d":"8695ef7a","chunk-12400a1a":"062e1055","chunk-13d7b3ca":"755220c8","chunk-13f6b85b":"3806a73f","chunk-13fd359c":"7ff6e732","chunk-14d43c3f":"d3c559d1","chunk-16459a5a":"4e5b8b5f","chunk-191e0601":"75742d6f","chunk-19c8ef9a":"63564dfe","chunk-1d02e364":"103859ea","chunk-1e6baee9":"df6bf3cd","chunk-274f192a":"50abb197","chunk-2a16261e":"ff1885da","chunk-0d3d56f7":"ed01cc7c","chunk-5e58ecf8":"f2769806","chunk-b1335a30":"00582bc3","chunk-2a7d697e":"4e76f122","chunk-2c534d9c":"3c2fdf0c","chunk-2d2180aa":"94d3e01d","chunk-2d22d97a":"e39fe8a4","chunk-2d237ae4":"9241f5c5","chunk-2f7151a2":"ad799f46","chunk-37fa4c96":"9a25d9c9","chunk-0e2cecd0":"79ff9754","chunk-79e268f1":"1064ed62","chunk-c0558610":"02d28fbf","chunk-3873cac0":"b046ed71","chunk-3add6324":"d14de651","chunk-4175ecc6":"63e4271f","chunk-42682332":"889641b3","chunk-fbab9544":"d6c3570b","chunk-47f9ce6c":"d055c359","chunk-502a87cd":"dcb8576d","chunk-5a410497":"37fe9259","chunk-a2d805a0":"8b6aa182","chunk-52025272":"88471a65","chunk-3026a14f":"98e26d57","chunk-37553fa4":"9e5756fb","chunk-b822f57a":"5dd7dc4e","chunk-5d3185bf":"a0261977","chunk-6724b5eb":"48e1a248","chunk-cbefe6ec":"c30c11cc","chunk-57185535":"07a65edb","chunk-5f0ed81d":"f72838e0","chunk-6e83591c":"22ec3898","chunk-3f57d4da":"6ea7e71c","chunk-734249da":"afb3f408","chunk-b974112a":"35df4026","chunk-fc54c184":"77e55cef","chunk-02ab776a":"4007a99a","chunk-16c8a83e":"aa170ac0","chunk-20f924b4":"3a7ad733","chunk-2e4a7db1":"e3a4a8bc","chunk-32e4068e":"e6a47d9b","chunk-4ab22d68":"009f9875","chunk-636894ce":"5f396d38","chunk-66112db5":"436adf8b","chunk-6f8fc6fa":"d6d14946","chunk-773f767c":"b4e8f29f","chunk-7a126b5a":"60cab39b","chunk-984ef95a":"1ac3edfc","chunk-b440f078":"a0550bf8","chunk-bd0f4ffa":"9a0e1a7d","chunk-dc2119f8":"edcca3b3","chunk-fc09c4fa":"91a11c3f","chunk-547a6a05":"addfddae","chunk-59a6a99e":"8ebacc35","chunk-5b8099c3":"8a125fbd","chunk-5c3f0fab":"530b6046","chunk-63784398":"8146e24f","chunk-6e6d13d8":"a432c8d6","chunk-6e08e574":"00e4519a","chunk-4d5ccf50":"09a7276e","chunk-4662eb88":"ac20f59c","chunk-4ac01fa6":"bf9250b2","chunk-6f288112":"858cf1af","chunk-b41597b8":"16e142c4","chunk-5775dc3e":"afc5dc3e","chunk-31112630":"5d0f4515","chunk-b5b70edc":"771ee519","chunk-3170bc66":"fe928053","chunk-7b50ff20":"7accb0f8","chunk-05082cce":"d999838e","chunk-2d0de55d":"f12cb6ab","chunk-89d92556":"fdaa99de","chunk-98239e8c":"37185b72","chunk-65626ea0":"32d54bdd","chunk-b790e292":"67b891cf","chunk-b992c740":"093c8618","chunk-d362118a":"451cccf1","chunk-d8a2acec":"24560616","chunk-e0887f78":"27250192","chunk-e5d0793c":"b8c44441","chunk-f470dd8c":"1fe03ac7","chunk-1469c76f":"0ad29f46","chunk-2d216214":"f3e31d29","chunk-2d216257":"69e90091","plotly":"216ac38c","lab-report":"d79b54fd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-071fba82":1,"chunk-0c5549d4":1,"chunk-0cf8451c":1,"chunk-0e331eef":1,"chunk-0f73822d":1,"chunk-12400a1a":1,"chunk-13d7b3ca":1,"chunk-13f6b85b":1,"chunk-13fd359c":1,"chunk-14d43c3f":1,"chunk-16459a5a":1,"chunk-191e0601":1,"chunk-19c8ef9a":1,"chunk-1d02e364":1,"chunk-1e6baee9":1,"chunk-274f192a":1,"chunk-2a16261e":1,"chunk-0d3d56f7":1,"chunk-5e58ecf8":1,"chunk-b1335a30":1,"chunk-2a7d697e":1,"chunk-2c534d9c":1,"chunk-2f7151a2":1,"chunk-37fa4c96":1,"chunk-0e2cecd0":1,"chunk-79e268f1":1,"chunk-c0558610":1,"chunk-3873cac0":1,"chunk-3add6324":1,"chunk-4175ecc6":1,"chunk-42682332":1,"chunk-fbab9544":1,"chunk-47f9ce6c":1,"chunk-502a87cd":1,"chunk-5a410497":1,"chunk-a2d805a0":1,"chunk-52025272":1,"chunk-3026a14f":1,"chunk-37553fa4":1,"chunk-b822f57a":1,"chunk-5d3185bf":1,"chunk-6724b5eb":1,"chunk-cbefe6ec":1,"chunk-57185535":1,"chunk-5f0ed81d":1,"chunk-3f57d4da":1,"chunk-734249da":1,"chunk-b974112a":1,"chunk-fc54c184":1,"chunk-02ab776a":1,"chunk-16c8a83e":1,"chunk-20f924b4":1,"chunk-2e4a7db1":1,"chunk-32e4068e":1,"chunk-4ab22d68":1,"chunk-636894ce":1,"chunk-66112db5":1,"chunk-6f8fc6fa":1,"chunk-773f767c":1,"chunk-7a126b5a":1,"chunk-984ef95a":1,"chunk-b440f078":1,"chunk-bd0f4ffa":1,"chunk-dc2119f8":1,"chunk-fc09c4fa":1,"chunk-547a6a05":1,"chunk-59a6a99e":1,"chunk-5b8099c3":1,"chunk-5c3f0fab":1,"chunk-63784398":1,"chunk-6e6d13d8":1,"chunk-6e08e574":1,"chunk-4d5ccf50":1,"chunk-4662eb88":1,"chunk-4ac01fa6":1,"chunk-6f288112":1,"chunk-b41597b8":1,"chunk-5775dc3e":1,"chunk-31112630":1,"chunk-b5b70edc":1,"chunk-3170bc66":1,"chunk-7b50ff20":1,"chunk-05082cce":1,"chunk-89d92556":1,"chunk-98239e8c":1,"chunk-65626ea0":1,"chunk-b790e292":1,"chunk-b992c740":1,"chunk-d362118a":1,"chunk-d8a2acec":1,"chunk-e0887f78":1,"chunk-e5d0793c":1,"chunk-f470dd8c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"plotly":"plotly","lab-report":"lab-report"}[chunkId]||chunkId) + "." + {"chunk-071fba82":"683080ab","chunk-0c5549d4":"df951c79","chunk-0cf8451c":"3f4cd7f4","chunk-0e331eef":"1b920430","chunk-0f73822d":"75a389cd","chunk-12400a1a":"5c60692c","chunk-13d7b3ca":"e8f7d898","chunk-13f6b85b":"a3c2dab6","chunk-13fd359c":"da4b8c4f","chunk-14d43c3f":"d92444ed","chunk-16459a5a":"149b7fbf","chunk-191e0601":"d27bcb53","chunk-19c8ef9a":"65152f58","chunk-1d02e364":"c7ae31e8","chunk-1e6baee9":"6e3210c1","chunk-274f192a":"efcee949","chunk-2a16261e":"9fd53477","chunk-0d3d56f7":"508ca2bd","chunk-5e58ecf8":"1fa9a167","chunk-b1335a30":"8ceb474c","chunk-2a7d697e":"a31fa40b","chunk-2c534d9c":"0537543a","chunk-2d2180aa":"31d6cfe0","chunk-2d22d97a":"31d6cfe0","chunk-2d237ae4":"31d6cfe0","chunk-2f7151a2":"aa526142","chunk-37fa4c96":"f9658b4c","chunk-0e2cecd0":"a3cc3304","chunk-79e268f1":"7aac2126","chunk-c0558610":"d1d74ba7","chunk-3873cac0":"5b985480","chunk-3add6324":"f781c2e3","chunk-4175ecc6":"65215780","chunk-42682332":"3fa3d1ea","chunk-fbab9544":"54c244d4","chunk-47f9ce6c":"8becd231","chunk-502a87cd":"855d6f57","chunk-5a410497":"2deeb5c6","chunk-a2d805a0":"6de14322","chunk-52025272":"42dab0bb","chunk-3026a14f":"8bfbaa1e","chunk-37553fa4":"f970c45f","chunk-b822f57a":"0f4b52b5","chunk-5d3185bf":"2c3ba84a","chunk-6724b5eb":"4e2fa6f4","chunk-cbefe6ec":"831f8a22","chunk-57185535":"35f75564","chunk-5f0ed81d":"c813fd1e","chunk-6e83591c":"31d6cfe0","chunk-3f57d4da":"b0fad789","chunk-734249da":"0c2e270a","chunk-b974112a":"ae2331e6","chunk-fc54c184":"33586c33","chunk-02ab776a":"f6920aef","chunk-16c8a83e":"1480d0ed","chunk-20f924b4":"05425cbb","chunk-2e4a7db1":"42f82d55","chunk-32e4068e":"11ac09ab","chunk-4ab22d68":"1bb0faf5","chunk-636894ce":"b434ddb0","chunk-66112db5":"62f196bb","chunk-6f8fc6fa":"c4fae449","chunk-773f767c":"dc145dca","chunk-7a126b5a":"343d36a9","chunk-984ef95a":"7c3328f0","chunk-b440f078":"fe9f6cc5","chunk-bd0f4ffa":"d15cc3bb","chunk-dc2119f8":"3707d28e","chunk-fc09c4fa":"5687e8d3","chunk-547a6a05":"158081ee","chunk-59a6a99e":"b76f9fca","chunk-5b8099c3":"b302ee23","chunk-5c3f0fab":"ba72cc7a","chunk-63784398":"a22cede9","chunk-6e6d13d8":"d805d906","chunk-6e08e574":"8cab2804","chunk-4d5ccf50":"648ee93b","chunk-4662eb88":"17403e1b","chunk-4ac01fa6":"cd742864","chunk-6f288112":"b753abfb","chunk-b41597b8":"22af79bc","chunk-5775dc3e":"2bfcd99b","chunk-31112630":"88f52b03","chunk-b5b70edc":"0185974c","chunk-3170bc66":"fd093fa5","chunk-7b50ff20":"5be1cb68","chunk-05082cce":"5c25d28f","chunk-2d0de55d":"31d6cfe0","chunk-89d92556":"c6c8fc81","chunk-98239e8c":"b14332e2","chunk-65626ea0":"60489974","chunk-b790e292":"6edf1c96","chunk-b992c740":"7cb4f369","chunk-d362118a":"7cd1e7b2","chunk-d8a2acec":"3f0c64b3","chunk-e0887f78":"2b40904c","chunk-e5d0793c":"1e6a3bfd","chunk-f470dd8c":"c63daa46","chunk-1469c76f":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","plotly":"31d6cfe0","lab-report":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
